import texts from './texts';
import {getOnboardingState} from './service/completionState';
import {ModalTypes} from './enums';

export const getModalType = () => {
    const {OB_step} = getOnboardingState();

    if (!OB_step) {
        return ModalTypes.welcomeMsg;
    }

    return ModalTypes.continueMsg;
};

export const handleRequiredError = (value: string = '') => {
    return value.trim() === '' ? texts.error_required : '';
};
// eslint-disable-next-line
const mail_format =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const handleEmailError = (value: string = '') => {
    if (value) {
        return value.match(mail_format) ? '' : texts.error_email;
    }
    return '';
};

export const handleWebsiteError = (value: string = '') => {
    if (value) {
        return /[\u0590-\u05FF]/.test(value) ? texts.error_website : '';
    }
    return '';
};

export const handleNumbersError = (value: string = '') => {
    if (value) {
        const digits = value.replace(/[-+ ()]/g, '');
        return digits.match(/^\d+$/) ? '' : texts.error_phone;
    }
    return '';
};
